import { initializeApp } from "firebase/app";
import {
  getRemoteConfig,
  fetchAndActivate,
  getValue,
} from "firebase/remote-config";

const MAINTENANCE_KEY = "maintenance_mode";

let remoteConfig = null;
let initTried = false;

function getRc() {
  if (initTried) return remoteConfig;
  initTried = true;
  const cfg = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
  };
  if (!cfg.apiKey || !cfg.projectId || !cfg.appId) return null;
  try {
    const app = initializeApp(cfg);
    remoteConfig = getRemoteConfig(app);
    remoteConfig.defaultConfig = { [MAINTENANCE_KEY]: false };
    remoteConfig.settings.minimumFetchIntervalMillis = 60000;
    remoteConfig.settings.fetchTimeoutMillis = 3000;
  } catch (e) {
    remoteConfig = null;
  }
  return remoteConfig;
}

export async function checkMaintenance() {
  try {
    const rc = getRc();
    if (!rc) return false;
    await fetchAndActivate(rc);
    return getValue(rc, MAINTENANCE_KEY).asBoolean();
  } catch (e) {
    return false;
  }
}
